export default function ({ app, store }) {
  // Проверяем наличие выбранного города в куках при инициализации приложения
  app.router.beforeEach((to, from, next) => {
    const selectedCityId = app.$cookies.get('selected_city');
    if (selectedCityId && !store.getters.getSelectedCity) {
      // Получаем список городов из глобальных настроек
      const globalSettings = store.getters['global/globalSettings'];
      if (globalSettings?.cities_to_choose) {
        // Находим город по ID
        const city = globalSettings.cities_to_choose.find(c => String(c.id) === String(selectedCityId));
        if (city) {
          // Сохраняем город в хранилище
          store.dispatch('setSelectedCity', city);
        }
      }
    }
    next();
  });
}
